var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13452_62866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2967 12.4996L42.1292 8.37003C36.6276 6.87213 32.5612 9.27322 31.0821 14.8818L26.0729 33.8776C24.5697 39.5781 26.9292 43.6499 32.4308 45.1478L47.5983 49.2774C53.1886 50.7994 57.1451 48.4472 58.6484 42.7467L63.6576 23.751C65.1366 18.1423 62.887 14.0216 57.2967 12.4996Z",
    fill: "url(#paint0_linear_13452_62866)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_13452_62866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3338 17.7012L43.0001 14.8877C39.2517 13.8671 36.4813 15.503 35.4736 19.3242L32.0608 32.2662C31.0366 36.15 32.6441 38.9242 36.3924 39.9447L46.7262 42.7582C50.5349 43.7952 53.2306 42.1927 54.2547 38.3088L57.6676 25.3668C58.6752 21.5456 57.1426 18.7382 53.3338 17.7012Z",
    fill: "#39B93A"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_13452_62866)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_13452_62866",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 15.1919,
    width: 46,
    height: 46,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9,
    y: 15.1919,
    width: 46,
    height: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9125 16.1919H22.2227C14.915 16.1919 10 21.405 10 29.159V47.0546C10 54.7867 14.915 59.9998 22.2227 59.9998H40.9125C48.2203 59.9998 53.1137 54.7867 53.1137 47.0546V29.159C53.1137 21.405 48.2203 16.1919 40.9125 16.1919Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.9125 16.1919H22.2227C14.915 16.1919 10 21.405 10 29.159V47.0546C10 54.7867 14.915 59.9998 22.2227 59.9998H40.9125C48.2203 59.9998 53.1137 54.7867 53.1137 47.0546V29.159C53.1137 21.405 48.2203 16.1919 40.9125 16.1919Z",
    fill: "#72DC60",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9125 17.1919C41.4648 17.1919 41.9125 16.7442 41.9125 16.1919C41.9125 15.6396 41.4648 15.1919 40.9125 15.1919V17.1919ZM40.9125 15.1919C40.3603 15.1919 39.9125 15.6396 39.9125 16.1919C39.9125 16.7442 40.3603 17.1919 40.9125 17.1919V15.1919ZM40.9125 15.1919H22.2227V17.1919H40.9125V15.1919ZM22.2227 15.1919C18.3209 15.1919 14.9925 16.5896 12.6433 19.0818C10.2989 21.5688 9 25.0698 9 29.159H11C11 25.4943 12.1586 22.5117 14.0986 20.4537C16.0338 18.4008 18.8168 17.1919 22.2227 17.1919V15.1919ZM9 29.159V47.0546H11V29.159H9ZM9 47.0546C9 51.1336 10.2993 54.6291 12.6437 57.1131C14.9928 59.6022 18.321 60.9998 22.2227 60.9998V58.9998C18.8167 58.9998 16.0335 57.7909 14.0982 55.7404C12.1582 53.6848 11 50.7077 11 47.0546H9ZM22.2227 60.9998H40.9125V58.9998H22.2227V60.9998ZM40.9125 60.9998C44.8145 60.9998 48.1377 59.602 50.4817 57.1122C52.8205 54.6278 54.1137 51.1324 54.1137 47.0546H52.1137C52.1137 50.7089 50.9602 53.6861 49.0254 55.7413C47.0957 57.7911 44.3184 58.9998 40.9125 58.9998V60.9998ZM54.1137 47.0546V29.159H52.1137V47.0546H54.1137ZM54.1137 29.159C54.1137 25.071 52.821 21.5701 50.4821 19.0827C48.138 16.5898 44.8145 15.1919 40.9125 15.1919V17.1919C44.3183 17.1919 47.0954 18.4006 49.025 20.4527C50.9598 22.5104 52.1137 25.4931 52.1137 29.159H54.1137Z",
    fill: "url(#paint1_linear_13452_62866)",
    mask: "url(#path-4-outside-1_13452_62866)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_13452_62866)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_13452_62866",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9979 45.2099C28.515 45.2099 28.0321 45.0237 27.6635 44.6492L22.5481 39.4513C21.8108 38.7022 21.8108 37.4887 22.5481 36.7418C23.2853 35.9927 24.4774 35.9905 25.2146 36.7396L28.9979 40.5838L37.8965 31.5418C38.6338 30.7927 39.8259 30.7927 40.5631 31.5418C41.3004 32.2909 41.3004 33.5044 40.5631 34.2535L30.3322 44.6492C29.9636 45.0237 29.4807 45.2099 28.9979 45.2099Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.9979 45.2099C28.515 45.2099 28.0321 45.0237 27.6635 44.6492L22.5481 39.4513C21.8108 38.7022 21.8108 37.4887 22.5481 36.7418C23.2853 35.9927 24.4774 35.9905 25.2146 36.7396L28.9979 40.5838L37.8965 31.5418C38.6338 30.7927 39.8259 30.7927 40.5631 31.5418C41.3004 32.2909 41.3004 33.5044 40.5631 34.2535L30.3322 44.6492C29.9636 45.0237 29.4807 45.2099 28.9979 45.2099Z",
    fill: "url(#paint2_linear_13452_62866)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5481 36.7418L22.6904 36.8823L22.6906 36.8821L22.5481 36.7418ZM28.9979 40.5838L28.8553 40.7241L28.9979 40.8689L29.1404 40.7241L28.9979 40.5838ZM40.5631 34.2535L40.4206 34.1132L40.5631 34.2535ZM30.3322 44.6492L30.4748 44.7894L30.3322 44.6492ZM28.9979 45.0099C28.5666 45.0099 28.1357 44.8439 27.806 44.5089L27.5209 44.7894C27.9285 45.2036 28.4634 45.4099 28.9979 45.4099V45.0099ZM27.806 44.5089L22.6906 39.3111L22.4055 39.5916L27.5209 44.7894L27.806 44.5089ZM22.6906 39.3111C22.0298 38.6397 22.0301 37.5512 22.6904 36.8823L22.4057 36.6013C21.5915 37.4263 21.5918 38.7648 22.4055 39.5916L22.6906 39.3111ZM22.6906 36.8821C23.3498 36.2123 24.4135 36.2107 25.0721 36.8799L25.3572 36.5993C24.5413 35.7703 23.2208 35.7731 22.4055 36.6015L22.6906 36.8821ZM25.0721 36.8799L28.8553 40.7241L29.1404 40.4435L25.3572 36.5993L25.0721 36.8799ZM29.1404 40.7241L38.0391 31.6821L37.754 31.4015L28.8553 40.4435L29.1404 40.7241ZM38.0391 31.6821C38.698 31.0126 39.7617 31.0126 40.4206 31.6821L40.7057 31.4015C39.8901 30.5728 38.5696 30.5728 37.754 31.4015L38.0391 31.6821ZM40.4206 31.6821C41.0812 32.3534 41.0812 33.442 40.4206 34.1132L40.7057 34.3938C41.5195 33.5669 41.5195 32.2285 40.7057 31.4015L40.4206 31.6821ZM40.4206 34.1132L30.1897 44.5089L30.4748 44.7894L40.7057 34.3938L40.4206 34.1132ZM30.1897 44.5089C29.86 44.8439 29.4291 45.0099 28.9979 45.0099V45.4099C29.5324 45.4099 30.0672 45.2036 30.4748 44.7894L30.1897 44.5089Z",
    fill: "url(#paint3_linear_13452_62866)",
    fillOpacity: 0.5,
    mask: "url(#path-6-inside-2_13452_62866)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_13452_62866",
    x: 17.7583,
    y: 0.590332,
    width: 54.2109,
    height: 56.4761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_13452_62866"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_13452_62866",
    x: -15,
    y: -8.80811,
    width: 93.1138,
    height: 93.8081,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13452_62866"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_13452_62866",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_13452_62866",
    x: 6.99512,
    y: 15.98,
    width: 49.1211,
    height: 44.23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_13452_62866"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454902 0 0 0 0 0.870588 0 0 0 0 0.376471 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_13452_62866",
    result: "effect2_dropShadow_13452_62866"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_13452_62866",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13452_62866",
    x1: 65.9998,
    y1: 14.8691,
    x2: 32.6366,
    y2: 34.9648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9BF763"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26AB5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13452_62866",
    x1: 16.863,
    y1: 21.2956,
    x2: 44.8986,
    y2: 55.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13452_62866",
    x1: 39.7604,
    y1: 33.5496,
    x2: 18.4797,
    y2: 34.4819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13452_62866",
    x1: 24.0549,
    y1: 35.7534,
    x2: 40.2908,
    y2: 35.8739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13452_62866"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.411621 8C0.411621 3.58172 3.99334 0 8.41162 0H61.5881C66.0064 0 69.5881 3.58172 69.5881 8V62C69.5881 66.4183 66.0064 70 61.5881 70H8.41162C3.99334 70 0.411621 66.4183 0.411621 62V8Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.bb15d5e67e1995a25235b5f58198e061.svg";
export { ForwardRef as ReactComponent };